var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPath6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 14,
    viewBox: "0 0 31 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.731196 14L0.558675 13.9857C0.469713 13.9669 0.389699 13.9292 0.32808 13.877C0.266462 13.8248 0.225814 13.7604 0.210935 13.6912C-0.159182 12.0068 -0.0411902 10.2814 0.556707 8.63511C1.1546 6.98878 2.21806 5.461 3.67311 4.15801C5.12817 2.85502 6.9399 1.80809 8.98234 1.09003C11.0248 0.371964 13.2489 0 15.5 0C17.7511 0 19.9752 0.371964 22.0177 1.09003C24.0601 1.80809 25.8718 2.85502 27.3269 4.15801C28.7819 5.461 29.8454 6.98878 30.4433 8.63511C31.0412 10.2814 31.1592 12.0068 30.7891 13.6912C30.7738 13.7604 30.7328 13.8248 30.671 13.877C30.6092 13.9291 30.529 13.9668 30.44 13.9857L30.1987 14H0.731196Z",
    fill: "#6D7278"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath6);
export default __webpack_public_path__ + "static/media/path6.75427f7cfeecc243a56b9a4556389338.svg";
export { ForwardRef as ReactComponent };